import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Spinner from './Spinner';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    box: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
    },
  }),
);

const PageLoading: React.FC<{}> = () => {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <Spinner />
    </Box>
  );
};

export default PageLoading;
